import { render, staticRenderFns } from "./roleLimits.vue?vue&type=template&id=2b17f163&scoped=true&"
import script from "./roleLimits.vue?vue&type=script&lang=js&"
export * from "./roleLimits.vue?vue&type=script&lang=js&"
import style0 from "./roleLimits.vue?vue&type=style&index=0&id=2b17f163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17f163",
  null
  
)

export default component.exports